import React from 'react';

// BRAND.md §8.2 stock states + generic order/vendor status chip.
const STATES = {
  in:        { bg: 'var(--status-success-bg)', fg: 'var(--status-success)',   dot: 'var(--status-success)', en: 'In stock',  ar: 'متوفر' },
  low:       { bg: 'var(--status-warn-bg)',    fg: 'var(--status-warn-dark)', dot: 'var(--status-warn)',    en: 'Low stock', ar: 'كمية محدودة' },
  out:       { bg: 'var(--sedra-line)',        fg: 'var(--sedra-ink-muted)',  dot: 'var(--sedra-ink-muted)',en: 'Out of stock', ar: 'غير متوفر' },
  pending:   { bg: 'var(--status-warn-bg)',    fg: 'var(--status-warn-dark)', dot: 'var(--status-warn)',    en: 'Pending',   ar: 'قيد المراجعة' },
  active:    { bg: 'var(--status-success-bg)', fg: 'var(--status-success)',   dot: 'var(--status-success)', en: 'Active',    ar: 'نشط' },
  new:       { bg: 'var(--status-info-bg)',    fg: 'var(--status-info)',      dot: 'var(--status-info)',    en: 'New',       ar: 'جديد' },
  seen:      { bg: 'var(--sedra-sage-wash)',   fg: 'var(--sedra-sage-ink)',   dot: 'var(--sedra-sage-ink)', en: 'Seen',      ar: 'مقروء' },
  confirmed: { bg: 'var(--status-success-bg)', fg: 'var(--status-success)',   dot: 'var(--status-success)', en: 'Confirmed', ar: 'مؤكد' },
  cancelled: { bg: 'var(--status-danger-bg)',  fg: 'var(--status-danger)',    dot: 'var(--status-danger)',  en: 'Cancelled', ar: 'ملغي' },
  suspended: { bg: 'var(--status-warn-bg)',    fg: 'var(--status-warn-dark)', dot: 'var(--status-warn)',    en: 'Suspended', ar: 'موقوف' },
  rejected:  { bg: 'var(--status-danger-bg)',  fg: 'var(--status-danger)',    dot: 'var(--status-danger)',  en: 'Rejected',  ar: 'مرفوض' },
};

/**
 * StatusChip — dot + label chip for stock states (BRAND.md §8.2) and order /
 * vendor status. Pass `lang="ar"` for the Arabic label, or `label` to override.
 */
export function StatusChip({ state = 'in', label, lang = 'en', style }) {
  const s = STATES[state] || STATES.in;
  const text = label || (lang === 'ar' ? s.ar : s.en);
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      padding: '4px 10px', borderRadius: 'var(--radius-pill)',
      fontFamily: 'var(--font-body)', fontSize: 12, fontWeight: 600,
      background: s.bg, color: s.fg, letterSpacing: 0, ...style,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: s.dot, flexShrink: 0 }} />
      {text}
    </span>
  );
}
